import React from 'react';
import clsx from 'clsx';

export type CardPadding = 'tight' | 'default' | 'loose';
export type CardElevation = 'flat' | 'raised' | 'glow';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding;
  elevation?: CardElevation;
}

const paddingClasses: Record<CardPadding, string> = {
  tight: 'p-3',
  default: 'p-5',
  loose: 'p-7',
};

const elevationClasses: Record<CardElevation, string> = {
  flat: 'shadow-ds-e1',
  raised: 'shadow-ds-e2',
  glow: 'shadow-ds-glow-accent',
};

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    { padding = 'default', elevation = 'flat', className, ...props },
    ref,
  ) => (
    <div
      ref={ref}
      className={clsx(
        'bg-surface-1 border border-white/[0.08] rounded-ds-xl',
        paddingClasses[padding],
        elevationClasses[elevation],
        className,
      )}
      {...props}
    />
  ),
);

Card.displayName = 'Card';

export default Card;
